import React from 'react';
import AiChatCitationChip from './AiChatCitationChip';
import AiChatProductCitationsTable from './AiChatProductCitationsTable';
import AiChatOrderCitationsTable from './AiChatOrderCitationsTable';
import AiChatQuoteCitationsTable from './AiChatQuoteCitationsTable';
import './AiChatStyle.css';

const isProductCitation = citation =>
  (citation?.entity_type || 'product') === 'product' && citation?.product_id;

const isOrderCitation = citation =>
  citation?.entity_type === 'order' && citation?.order_id;

const isQuoteCitation = citation =>
  citation?.entity_type === 'quote' && citation?.quote_id;

const isTableCitation = citation =>
  isProductCitation(citation) ||
  isOrderCitation(citation) ||
  isQuoteCitation(citation);

/**
 * Renders assistant citations: products/orders/quotes as tables; other entities as chips.
 *
 * @param {Object} props
 * @param {Array<Object>} props.citations
 * @returns {JSX.Element|null}
 */
const AiChatCitations = ({ citations = [] }) => {
  if (!Array.isArray(citations) || citations.length === 0) return null;

  const productCitations = citations.filter(isProductCitation);
  const orderCitations = citations.filter(isOrderCitation);
  const quoteCitations = citations.filter(isQuoteCitation);
  const otherCitations = citations.filter(citation => !isTableCitation(citation));

  return (
    <div className="ai-chat-citations">
      {productCitations.length > 0 && (
        <AiChatProductCitationsTable citations={productCitations} />
      )}
      {orderCitations.length > 0 && (
        <AiChatOrderCitationsTable citations={orderCitations} />
      )}
      {quoteCitations.length > 0 && (
        <AiChatQuoteCitationsTable citations={quoteCitations} />
      )}
      {otherCitations.length > 0 && (
        <div className="ai-chat-citations__chips">
          {otherCitations.map((citation, idx) => (
            <AiChatCitationChip
              key={`${citation.entity_type}-${citation.supplier_id || citation.project_id}-${idx}`}
              citation={citation}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AiChatCitations;
